import React, { useEffect, useState } from "react";
import './MonitoreoServicios.scss'
import TitleView from "../../../components/atoms/TitleView/TitleView";
import { GetHora } from "../../../CustomHooks/useGetHora";
import MenuFrontalSelector from "../../../components/molecules/MenuFrontalSelector/MenuFrontalSelector";
import InputLista from "../../../components/atoms/InputLista/InputLista";
import Button from "../../../components/atoms/Button/Button";
import ButtonGris from "../../../components/atoms/ButtonGris/ButtonGris";
import TablaMonitoreo from "../../../components/molecules/TablaMonitoreo/TablaMonitoreo";
import markerIncon from '../../../assets/icons/marker.svg'
import notofocacionesIcon from '../../../assets/icons/notificaciones.svg'
import comentariosIcon from '../../../assets/icons/comentarios.png'
import HoverText from "../../../components/atoms/HoverText/HoverText";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { convertirCadenaAArray } from "../../../utilities/convertirCadenaAArray";
import { getClients, getIndicadores, getTables, mandarMensaje } from "./MonitoreoServiciosIntegracion";
import { Tooltip } from "@mui/material";
import GlovalCard from "../../../components/atoms/GlovalCard/GlovalCard";
const MonitoreoServicios = () => {
    const navigate = useNavigate()
    // const [unaHoraAntes,setUnaHoraAntes] = useState(useGetHora(-1))
    const [unaHoraAntes, setUnaHoraAntes] = useState(GetHora(-1))
    // const [unaHoraDespues,setUnaHoraDespues] = useState(useGetHora(1))
    const [unaHoraDespues, setUnaHoraDespues] = useState(GetHora(1))
    // const [horaActual,setHoraActual] = useState(useGetHora())
    const [horaActual, setHoraActual] = useState(GetHora())
    const [horaActualMas10min] = useState(GetHora(0, 10))
    const [opcionIndicadores, setOpcionIndicadores] = useState("Indicadores Suma")
    const opciones = ['Indicadores Suma', 'Indicadores General']
    const opcionesTablas = ['Sin confirmar y programados', 'En ruta y confirmados', 'Terminados rango 10 min', 'Terminados y cancelados', 'Códigos de error']
    const [opcionesTabla, setOpcionesTabla] = useState("Sin confirmar y programados")
    // filtros
    const [tipo, setTipo] = useState('todosTipo')
    const [filtrarPorProvedor, setFiltrarPorProvedor] = useState('todosProveedor')
    const [cliente, setCliente] = useState('')
    const [actualizarTablas, setActualizarTablas] = useState(true)
    const [actualizarBucle, setActualizarBucle] = useState(true)




    // integracion
    const [indicadores, setIndicadores] = useState([])
    const [clientes, setClientes] = useState([])
    const [tablesInfo, setTablesInfo] = useState([])


    useEffect(() => {

        const interval = setInterval(async () => {
            setActualizarBucle(!actualizarBucle)

        }, 10000); // 10000 milisegundos = 10 segundos
        return () => {
            clearInterval(interval);
        };

    }, [actualizarBucle]);


    // integracion
    useEffect(() => {
        setUnaHoraAntes(GetHora(-1))
        // const [unaHoraDespues,setUnaHoraDespues] = useState(useGetHora(1))
        setUnaHoraDespues(GetHora(1))
        // const [horaActual,setHoraActual] = useState(useGetHora())
        setHoraActual(GetHora())
        const data = {
            fecha_inicio: unaHoraAntes,
            fecha_fin: unaHoraDespues,
            filtro_tipo: tipo,
        }
        const TablesData = {
            fecha_inicio: unaHoraAntes,
            fecha_fin: unaHoraDespues,
            tipo: tipo,
            proveedor: filtrarPorProvedor,
            cliente: cliente?.code,
            rango10m: '',
            numero_de_tabla: opcionesTabla
        }
        getIndicadores(data, setIndicadores)
        getClients(setClientes)
        getTables(TablesData, setTablesInfo)

    }, [actualizarBucle])

    useEffect(() => {
        if (opcionesTabla != 'Terminados rango 10 min') {
            const TablesData = {
                fecha_inicio: unaHoraAntes,
                fecha_fin: unaHoraDespues,
                tipo: tipo,
                proveedor: filtrarPorProvedor,
                cliente: cliente?.code,
                rango10m: '',
            }
            getTables(TablesData, setTablesInfo)
        }
        else {

            const TablesData = {
                fecha_inicio: horaActual,
                fecha_fin: horaActualMas10min,
                tipo: tipo,
                proveedor: filtrarPorProvedor,
                cliente: cliente?.code,
                rango10m: '',
            }
            getTables(TablesData, setTablesInfo)
        }
    }, [opcionesTabla, actualizarTablas, actualizarBucle])

    // body

    const sendMessage = (rowData) => {

        mandarMensaje(rowData.PROVEEDOR_TELEFONO, "Hola :" + rowData.OPERADOR + " Se le recuerda que tiene la bitácora " + rowData.ID + " confirmada y lista para iniciar.")
    }
    const statusBody = (rowData) => {
        // console.log("rowdata.CONFIRMADA", rowData.ID == 2772177 ? rowData : "");


        return (
            <div className="estatusContainer">
                <div className="statusSection">

                    {
                        rowData.ESTATUS == "NO CONFIRMADO" ?
                            <>
                                <div className="servicioSinConfirmar">Servicio sin confirmar</div>
                                {
                                    rowData.PROGRAMABLE == 0 && rowData.PROVEEDOR_TELEFONO ?
                                        <>
                                            <Button className="mensajeAOperador"
                                                onClick={() => { sendMessage(rowData) }}
                                            >Enviar mensaje al operador</Button>
                                        </> : ""
                                }
                            </> : ""
                    }
                    {
                        rowData.ESTATUS == "SERVICIO PROGRAMADO" ?
                            <>
                                <div className="ServicioProgramado">Servicio programado</div>
                            </> : ""
                    }
                    {
                        rowData.ESTATUS == "EN RUTA" ?
                            <>
                                <div className="enRuta">Operadores en ruta</div>
                            </> : ""
                    }
                    {
                        rowData.ESTATUS == "CONFIRMADO" ?
                            <>
                                <div className="mensajeAOperador">Servicio confirmado</div>
                            </> : ""
                    }
                    {
                        rowData.ESTATUS == "TERMINADO" ?
                            <>
                                <div className="terminado">Servicio terminado</div>

                            </> : ""
                    }
                    {
                        rowData.ESTATUS == "CANCELADO" ?
                            <>
                                <div className="cancelado">Servicio cancelado</div>
                            </> : ""
                    }



                </div>
                <div className="unidad">{rowData.ID_UNIDAD ? "U-" + rowData.ID_UNIDAD : !rowData.ID_UNIDAD && rowData.PROVEEDOR_SERVICIO != 1 ? 'Aliado' : ""}</div>
                <Tooltip title={"Ver unidad en mapa"}>
                    <NavLink to={`https://mapas.sumaenlinea.mx/${rowData.INICIALES}`} target="_blank" rel="noopener noreferrer">
                        <div className="unidadEnMapa"><img src={markerIncon} alt="" onClick={() => { navigate(``) }} /></div>
                    </NavLink>
                </Tooltip>

                <Tooltip title={"Notificar al cliente"}>
                    <NavLink to={`https://sumaenlinea.mx/cgi-bin/e_web.EXE/Agrega_Registro?Modulo=TR_NOTSER&Indice=NUEVO&cliente=${rowData.CLIENTE}&ruta=${rowData.ID_RUTA}&cerrar=1`} target="_blank" rel="noopener noreferrer">
                        <div className="unidadEnMapa"><img src={notofocacionesIcon} alt="" onClick={() => { navigate("#") }} /></div>
                    </NavLink>
                </Tooltip>
                {
                    rowData.COMENTARIOS ? <>
                        <Tooltip title={rowData.COMENTARIOS}>
                            <div className="unidadEnMapa"><img src={comentariosIcon} alt="" onClick={() => { navigate("#") }} /></div>
                        </Tooltip>
                    </> : ""
                }
            </div>
        )
    }
    const StatusBodySignificados = () => {
        return (
            <div className="estatusContainer" style={{ flexDirection: "column", alignItems: "flex-start", gap: "30px" }}>
                <div className="statusSection" style={{ gap: "30px" }}>
                    <div className="descripcion-conatainer">
                        <div className="servicioSinConfirmar">Servicio sin confirmar</div>
                        <div className="">
                            Servicio que está en 30 min o menos de iniciar y no se ha confirmado en la aplicación.
                        </div>
                    </div>
                    <div className="descripcion-conatainer">
                        <Button className="mensajeAOperador">Enviar mensaje al operador</Button>
                        <div className="">
                            Cuando un servicio este sin confirmar y dentro de los 30 min. previos a iniciar su ruta aparecerá este botón con el cual podrás enviar un mensaje por whatsApp al operador que esta asignado para ese servicio. Solo necesitas dar click y el mensaje se enviará.
                        </div>
                    </div>
                    <div className="descripcion-conatainer">
                        <div className="ServicioProgramado">Servicio programado</div>
                        <div className="">
                            Servicio que se asignó a un operador pero que no está dentro del tiempo límite de inicio y no se ha confirmado en la aplicación.
                        </div>
                    </div>
                    <div className="descripcion-conatainer">
                        <Tooltip title={2}>
                            <div className="mensajeAOperador">Mensajes enviados</div>
                        </Tooltip>
                        <div className="">
                            Cuando mandes un mensaje al operador para que confirme la bitácora aparecerá la cantidad mensaje que se han enviado al operador solicitando que confirme su servicio en la aplicación.
                        </div>
                    </div>
                    <div className="descripcion-conatainer">
                        <div className="enRuta">Operadores en ruta</div>
                        <div className="">
                            Servicio que ya fue confirmado en la aplicación y está dentro de su tiempo de ruta.
                        </div>
                    </div>
                    <div className="descripcion-conatainer">
                        <div className="mensajeAOperador">Servicio confirmado</div>
                        <div className="">
                            Servicio que ya fue confirmado en la aplicación y que aun no comienza su tiempo de ruta.
                        </div>
                    </div>
                    <div className="descripcion-conatainer">
                        <div className="terminado">Servicio terminado</div>
                        <div className="">
                            Servicio que ya se dió por terminado en la aplicación por parte del operador.
                        </div>
                    </div>
                    <div className="descripcion-conatainer">
                        <div className="cancelado">Servicio cancelado</div>
                        <div className="">
                            Servicio ha sido cancelado.
                        </div>
                    </div>

                </div>
                <div className="descripcion-conatainer">
                    <div className="unidad">U-29 | Aliado</div>
                    <div className="">
                        El servicio lo realiza uno de nuestros aliados o una unidad.
                    </div>
                </div>
                <div className="descripcion-conatainer">
                    <Tooltip title={"Ver unidad en mapa"}>
                        <div className="unidadEnMapa"><img src={markerIncon} alt="" onClick={() => { navigate("#") }} /></div>
                    </Tooltip>
                    <div className="">
                        Este botón muestra la unidad en el mapa.
                    </div>
                </div>
                <div className="descripcion-conatainer">
                    <Tooltip title={"Notificar al cliente"}>
                        <div className="unidadEnMapa"><img src={notofocacionesIcon} alt="" onClick={() => { navigate("#") }} /></div>
                    </Tooltip>
                    <div className="">
                        Este botón te permite enviar una notificación por WhatsApp a nuestros clientes.
                    </div>
                </div>
                <div className="descripcion-conatainer">
                    <Tooltip title={"comentario"}>
                        <div className="unidadEnMapa"><img src={comentariosIcon} alt="" onClick={() => { navigate("#") }} /></div>
                    </Tooltip>
                    <div className="">
                        Se muestra cuando el servicio tiene algun comentario.
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className="MonitoreoServicios">
            <TitleView title="Monitoreo">
                <div className="fechaTitulo">
                    <div className="fechaActual">{horaActual}</div>
                    <div className="horasContainer">
                        <div>DE &nbsp;</div>
                        <div className="hora">{unaHoraAntes}</div>
                        <div>&nbsp; A &nbsp;</div>
                        <div className="hora">{unaHoraDespues}</div>
                    </div>
                </div>
            </TitleView>
            <GlovalCard>
                <div className="indicadoresContainew">
                    <div className="div1">
                        <MenuFrontalSelector maxWidth="180px" opciones={opciones} setSelected={setOpcionIndicadores} selected={opcionIndicadores}></MenuFrontalSelector>
                        {
                            opcionIndicadores === "Indicadores Suma" ?
                                <>
                                    <div className="estadisticas">
                                        <div className="textoEstadistica">TOTAL <div>{indicadores.TOTAL_SUMA}</div></div>
                                        <div className="textoEstadistica">CONFIRMADOS <div>{indicadores.CONFIRMADOS_SUMA} </div></div>
                                        <div className="textoEstadistica">SIN CONFIRMAR <div>{indicadores.SIN_CONFIRMAR_SUMA}</div></div>
                                        <div className="textoEstadistica">FINALIZADOS<div>{indicadores.TERMINADO_SUMA}</div></div>
                                    </div>
                                </> :
                                opcionIndicadores === "Indicadores General" ?
                                    <>
                                        <div className="estadisticas">
                                            <div className="textoEstadistica">TOTAL <div>{indicadores.TOTAL}</div></div>
                                            <div className="textoEstadistica">SUMA <div>{indicadores.TOTAL_SUMA}</div></div>
                                            <div className="textoEstadistica">ALIADOS <div>{indicadores.ALIADOS}</div></div>
                                            <div className="textoEstadistica">CONFIRMADOS<div>{indicadores.CONFIRMADOS}</div></div>
                                            <div className="textoEstadistica">SIN CONFIRMAR<div>{indicadores.SIN_CONFIRMAR}</div></div>
                                            <div className="textoEstadistica">FINALIZADOS SUMA<div>{indicadores.TERMINADO_SUMA}</div></div>
                                        </div>
                                    </> :
                                    ""
                        }
                    </div>
                    <div className="div2">
                        <div className="filtros">
                            <div className="checkContainer">
                                <div className="filtro">
                                    <b className="titulo-filtro">Filtrar por tipo</b>
                                    <div className="checks">
                                        <input onChange={(e) => { setTipo(e.target.value) }} checked={tipo == "todosTipo" ? true : false} type="radio" name="optionTipo" value="todosTipo" />
                                        Todos
                                        <input onChange={(e) => { setTipo(e.target.value) }} checked={tipo == "especiales" ? true : false} type="radio" name="optionTipo" value="especiales" />
                                        Especiales
                                        <input onChange={(e) => { setTipo(e.target.value) }} checked={tipo == "empresariales" ? true : false} type="radio" name="optionTipo" value="empresariales" />
                                        Empresariales
                                    </div>
                                    <b style={{ width: "100%" }}>
                                        <InputLista placeholder={"Seleccióne un cliente"} titulo={"Cliente"} obligatory={false} value={cliente} optionLabel="name" onChange={(e) => { setCliente(e.value) }} options={clientes}></InputLista>
                                    </b>
                                </div>
                                <div className="filtro">
                                    <b className="titulo-filtro">Filtrar por proveedor</b>
                                    <div className="checks">
                                        <input onChange={(e) => { setFiltrarPorProvedor(e.target.value) }} checked={filtrarPorProvedor == "todosProveedor" ? true : false} type="radio" name="option" value="todosProveedor" />
                                        Todos
                                        <input onChange={(e) => { setFiltrarPorProvedor(e.target.value) }} checked={filtrarPorProvedor == "suma" ? true : false} type="radio" name="option" value="suma" />
                                        Suma
                                        <input onChange={(e) => { setFiltrarPorProvedor(e.target.value) }} checked={filtrarPorProvedor == "aliados" ? true : false} type="radio" name="option" value="aliados" />
                                        Aliados
                                    </div>
                                    <div className="buttonContainer">
                                        <Button width="100%" onClick={() => { setActualizarTablas(!actualizarTablas) }}>Filtrar</Button>
                                        <ButtonGris width="100%" onClick={() => { setCliente(''); setActualizarTablas(!actualizarTablas) }}>Limpiar</ButtonGris>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="selectorContainer">
                    <MenuFrontalSelector className={"selector"} opciones={opcionesTablas} setSelected={setOpcionesTabla} selected={opcionesTabla}></MenuFrontalSelector>
                    {
                        opcionesTabla === "Sin confirmar y programados" ?
                            <div className="tablaMonitoreo">
                                <TablaMonitoreo data={tablesInfo.noConfirmados_y_programados} statusBody={statusBody}></TablaMonitoreo>
                            </div>
                            :
                            opcionesTabla === "En ruta y confirmados" ?
                                <div className="tablaMonitoreo">
                                    <TablaMonitoreo data={tablesInfo.en_ruta_y_confirmados} statusBody={statusBody}></TablaMonitoreo>
                                </div>
                                :
                                opcionesTabla === "Terminados rango 10 min" ?
                                    <div className="tablaMonitoreo">
                                        <TablaMonitoreo data={tablesInfo.terminados_rango_10_min} statusBody={statusBody}></TablaMonitoreo>
                                    </div>
                                    :
                                    opcionesTabla === "Terminados y cancelados" ?
                                        <div className="tablaMonitoreo">
                                            <TablaMonitoreo data={tablesInfo.terminados_y_cancelados} statusBody={statusBody}></TablaMonitoreo>
                                        </div>
                                        :
                                        opcionesTabla === "Códigos de error" ?
                                            <div className="tablaMonitoreo">
                                                <StatusBodySignificados></StatusBodySignificados>
                                            </div>
                                            : ""
                    }
                </div>
            </GlovalCard>
        </div>
    )
}
export default MonitoreoServicios